import API_ENDPOINTS from './api';                              // adjust path
import {
  setTestData,
  setTestDataLoading,
  setTestDataError,
} from '../Redux_Services/slices/testDataSlice'
import {sortTestsByPrefix} from "../Utils/Functions"

/**
 * Async thunk: dispatch(fetchAllTestData())
 */
export const fetchAllTestData = () => async (dispatch) => {
  try {
    // 1. turn the spinner on
    dispatch(setTestDataLoading(true));

    // 2. grab token (safe default values)
    const { token = '' } = JSON.parse(
      localStorage.getItem('userDetails') || '{}'
    );

    // 3. make the request
    const res = await fetch(API_ENDPOINTS.fetchAllTest, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // 4. handle non‑200 statuses as errors
    if (!res.ok) {
      throw new Error(`Server responded ${res.status}`);
    }

    // 5. parse JSON once
    const { data: rawTests } = await res.json();
   // ↙️ just reorder the flat array here
   const sortedFlat = sortTestsByPrefix(rawTests);

   // push the sorted array into Redux
   dispatch(setTestData(sortedFlat));
  } catch (err) {
    console.error('❌ fetchAllTestData error:', err);
    dispatch(
      setTestDataError({
        error: true,
        message: err.message || 'Unknown error',
      })
    );
  } finally {
    // 7. spinner off in both success & error paths
    dispatch(setTestDataLoading(false));
  }
};
